import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Smooth-scrolls to the top whenever the route changes (footer links, nav,
 * cards). Back/forward navigation is left alone so the browser can restore
 * the previous position, and `#anchor` links scroll to their own target.
 * Users who prefer reduced motion get an instant jump instead.
 */
export function RouteScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  const previousPath = useRef(pathname);

  useEffect(() => {
    if (previousPath.current === pathname) return;
    previousPath.current = pathname;
    if (navigationType === 'POP' || hash) return;

    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  }, [pathname, hash, navigationType]);

  return null;
}
